import Block from '@components/Layout/Block';
import { font, query, space } from '@design/templateFns';
import React, { FC, useEffect, useRef } from 'react';
import styled from 'styled-components';

interface UnwrappedGenericEmbedProps {
  embedCode: string;
}

export const UnwrappedGenericEmbed: FC<UnwrappedGenericEmbedProps> = ({ embedCode }) => {
  return (
    <React.Fragment>
      {embedCode && <div dangerouslySetInnerHTML={{ __html: embedCode }} />}
    </React.Fragment>
  );
};

interface AsyncGenericEmbedProps {
  embedCode: string;
}

export const AsyncGenericEmbed: FC<AsyncGenericEmbedProps> = ({ embedCode }) => {
  const embedRef = useRef<HTMLDivElement>(null);
  //extract the src from the embedCode
  const extractedSrc = embedCode?.match(/src="([^"]*)"/)?.[1];

  useEffect(() => {
    if (embedRef.current) {
      const script = document.createElement('script');
      script.src = extractedSrc!;
      script.async = true;
      embedRef.current.appendChild(script);
    }
  }, []);

  return (
    <React.Fragment>
      {embedCode && <div ref={embedRef} dangerouslySetInnerHTML={{ __html: embedCode }} />}
    </React.Fragment>
  );
};

export interface GenericEmbedProps {
  header?: string;
  embedCode: string;
  async: boolean;
}

const GenericEmbed: FC<GenericEmbedProps> = ({ header, embedCode, async }) => {
  return (
    <Block>
      {header && <Header>{header}</Header>}
      {async ? (
        <AsyncGenericEmbed embedCode={embedCode} />
      ) : (
        <UnwrappedGenericEmbed embedCode={embedCode} />
      )}
    </Block>
  );
};

export default GenericEmbed;

const Header = styled.h2`
  ${font('headline-md')};
  padding-bottom: ${space('sm')};
  text-align: center;

  @media screen and (${query.below('tablet')}) {
    ${font('headline-xs')};
  }
`;
